import type React from 'react';
import { createContext, useContext } from 'react';
import { type ISortableWidgetEditorProps } from '../ISortableWidgetEditorProps.ts';

export interface EngineReactComponentsContext {
  sortableWidgetEditor: React.ComponentType<ISortableWidgetEditorProps>;
}

export const EngineReactComponentsContext =
  createContext<EngineReactComponentsContext>({
    sortableWidgetEditor: () => null,
  });

export function useEngineReactComponentsContext() {
  return useContext(EngineReactComponentsContext);
}
